<template>
  <div>
    <q-card class="my-card">
      <q-card-section>
        <div class="row">
          <div class="col-5 container-serv">
            <div class="row title-row">
              <div class="title">Datos servicio</div>
            </div>
            <div>
              <q-toggle
                data-cy="toggle-visible-serv"
                color="primary"
                v-model="visible"
                label="Visible en Catálogo"
                left-label
              />
            </div>
            <div>
              <q-toggle
                data-cy="toggle-tipo-indicadores"
                color="primary"
                v-model="typeIndicadores"
                label="Tipo Indicadores"
                left-label
              />
            </div>
            <div class="input-row">
              <q-input
                data-cy="name-servicio"
                v-model="v$.name.$model"
                outlined
                debounce="1000"
                :error="v$.name.$error"
                label="*Nombre servicio"
                counter
                maxlength="255"
                class="col-12"
              >
                <template v-slot:error>Dato obligatorio.</template>
                <template v-slot:hint>Restante</template>
              </q-input>
            </div>
            <div class="input-row" data-cy="serv-apps">
              <q-select
                data-cy="select-app"
                outlined
                use-input
                clearable
                  hide-selected
                  fill-input
                v-model="appSelected"
                :options="appOptions"
                  input-debounce="0"
                @filter="filterFn"
                option-value="id"
                option-label="name"
                label="Aplicación asignada"
                class="col-12"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      Sin resultados
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="input-row">
              <q-input
                data-cy="description-serv"
                label="Texto descriptivo"
                outlined
                type="textarea"
                rows="4"
                counter
                maxlength="512"
                v-model="descripcion"
                debounce="1000"
                class="col-12"
                :input-style="{ resize: 'none' }"
              >
                <template v-slot:hint>Restante</template>
              </q-input>
            </div>
            <div class="input-row">
                <q-input
                  data-cy="url-servicio"
                  outlined
                  debounce="1000"
                  v-model="url"
                  :error="v$.url.$error"
                  label="URL"
                >
                  <template v-slot:error>URL no válida.</template>
                </q-input>
              </div>
            <div class="input-row">
              <q-input
                data-cy="order-serv"
                v-model="v$.orden.$model"
                outlined
                debounce="1000"
                :error="v$.orden.$error"
                label="*Orden"
                type="number"
                min="0"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </div>
          </div>
          <div class="col-3 container-images">
            <div>
              <UploadImage
                data-cy="logotipo-serv"
                imgDefault="img/logo-dinapsis-aplicaciones.svg"
                label="CAMBIAR LOGO"
                v-model="imgLogotipo"
                :showPreview="{
                  show: true,
                  sizes: {
                    width: '161px',
                    height: '158px',
                  },
                  ratio: 16 / 9,
                }"
                @input="updateLogotipo = true"
              />
            </div>
            <div class="divUploadDocumento">
              <UploadFile
                  data-cy="documento-serv"
                  label="CAMBIAR DOCUMENTO"
                  labelDeleteFile ="ELIMINAR DOCUMENTO"
                  v-model="documento"
                  @input="updateDocumento = true"
                  :isLoading="isUploadingDocumento"
                  @deleteFile="deleteDocumento()"
                  accept="pdf"
                  typeFile="documento"
                  :fileSize=10485760
                />
            </div>
          </div>
          <div class="col-4 container-video">
            <div>
              <UploadImage
                data-cy="imagen-serv"
                imgDefault="img/defecto.svg"
                label="CAMBIAR IMAGEN"
                v-model="imgImagen"
                :showPreview="{
                  show: true,
                  sizes: {
                    width: '161px',
                    height: '158px',
                  },
                  ratio: 16 / 9,
                }"
                @input="updateImagen = true"
              />
            </div>
            <div class="divUploadVideo">
              <UploadFile
                  data-cy="video-serv"
                  label="CAMBIAR VIDEO"
                  labelDeleteFile ="ELIMINAR VIDEO"
                  v-model="video"
                  @input="updateVideo = true"
                  :isLoading="isUploading"
                  @deleteFile="deleteVideo()"
                  accept="video/mp4"
                  typeFile="video"
                  :fileSize=maxFileSizeVideo
                />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-5 info-box">
            <div style="margin-right: 6px">
              <q-img
                :src="require('@/assets/img/info-24px.svg')"
                width="24px"
                height="24px"
              />
            </div>
            <div class="txt-info">
              SI EL NOMBRE O DESCRIPCIÓN EXCEDE LOS LÍMITES RECOMENDADOS, LA
              INFORMACIÓN PUEDE NO VISUALIZARSE CORRECTAMENTE EN TODOS LOS
              DISPOSITIVOS.
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Validation from '@/components/shared/mixins/Validation.js';
import Formats from '@/components/shared/mixins/Formats.js';
import UploadImage from '@/shared/uploadImage/components/UploadImage.vue';
import Resources from '@/components/shared/mixins/Resources.js';
import UploadFile from '@/shared/uploadFile/components/UploadFile.vue';
import { mapGetters } from 'vuex';

import { QToggle, QImg } from 'quasar';

const checkUrlOrEmpty = (url) => Validation.methods.validateURL(url) || url === '' || url === null || url === undefined;

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    QToggle,
    QImg,
    UploadImage,
    UploadFile
  },
  mixins: [Message, Validation, Formats, Resources],
  validations: {
    name: { required },
    visible: { required },
    orden: { required },
    url: { checkUrlOrEmpty }
  },
  props: {
    dataServ: Object,
    arrayApps: Array,
    isLoading: Boolean,
    isNew: Boolean,
    eventSaveServicio: { type: String, required: true },
    eventSaveAplicacion: { type: String, required: true }
  },
  data () {
    return {
      arrayServ: this.dataServ,
      idServ: null,
      name: null,
      appSelected: null,
      appOptions: this.arrayApps,
      selected: [],
      descripcion: null,
      imgLogotipo: null,
      imgImagen: null,
      visible: false,
      typeIndicadores: false,
      orden: null,
      updateLogotipo: false,
      updateImagen: false,
      video: {
        file: null,
        name: ''
      },
      updateVideo: false,
      isUploading: false,
      documento: {
        file: null,
        name: ''
      },
      updateDocumento: false,
      isUploadingDocumento: false,
      url: null,
      videoId: null,
      documentoId: null
    };
  },
  computed: {
    ...mapGetters({
      maxFileSizeVideo: 'PF/maxFileSizeVideo'
    })
  },
  mounted () {
    this.$eventHub.$on(this.eventSaveServicio, ({ callback, rejected }) =>
      this.checkToSave(callback, rejected)
    );
    this.$eventHub.$on(this.eventSaveAplicacion, ({ callback, rejected }) =>
      this.setAppServ(callback, rejected)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off(this.eventSaveServicio);
    this.$eventHub.$off(this.eventSaveAplicacion);
  },
  methods: {
    // Check if name exist before save
    async checkToSave (callback, rejected) {
      this.v$.$touch();

      let returnValue = {
        data: null,
        status: false
      };

      if (this.v$.$error) return rejected(returnValue);

      let name = this.name;
      let orden = this.orden;
      if (
        name !== '' &&
        name !== null &&
        name !== '' &&
        orden !== '' &&
        orden !== null
      ) {
        let returnValue = await this.saveValues();
        callback(returnValue);
      } else {
        rejected(returnValue);
      }
    },
    // Save service values
    async saveValues () {
      let descripcion = this.descripcion;

      let dataArray = {
        name: this.name,
        description: descripcion,
        visible: this.visible,
        displayOrder: parseInt(this.orden),
        url: this.url,
        tags: this.fillTags()
      };

      let result = false;

      if (this.isNew) {
        result = await this.saveNewServ(dataArray);
      } else {
        result = await this.saveUpdates(dataArray);
      }

      await this.saveFiles();
      return result;
    },
    async saveFiles () {
      if (this.updateLogotipo) {
        await this.saveFile('Servicio', this.idServ, 'Logotipo', this.imgLogotipo);
      }
      if (this.updateImagen) {
        await this.saveFile('Servicio', this.idServ, 'Imagen', this.imgImagen);
      }
      if (this.updateVideo) {
        if (this.video.file !== null) {
          await this.saveVideo();
        } else {
          await this.deleteFile(this.videoId);
        }
      }
      if (this.updateDocumento) {
        if (this.documento.file !== null) {
          await this.saveDocumento();
        } else {
          await this.deleteFile(this.documentoId);
        }
      }
    },
    async saveVideo () {
      this.isUploading = true;
      await this.saveFile('Servicio', this.idServ, 'Video', this.video.file).then(response => {
        this.isUploading = false;
        this.updateVideo = false;
      }).catch(err => {
        this.showError(err);
        this.isUploading = false;
      });
    },
    async saveDocumento () {
      this.isUploadingDocumento = true;
      await this.saveFile('Servicio', this.idServ, 'Documento', this.documento.file).then(response => {
        this.isUploadingDocumento = false;
        this.updateDocumento = false;
      }).catch(err => {
        this.showError(err);
        this.isUploadingDocumento = false;
      });
    },
    async saveNewServ (dataArray) {
      let request = {
        controller: '/Servicio/',
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          this.idServ = response.data.id;
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);

          responseData = {
            data: null,
            status: false
          };
        });
      return responseData;
    },
    async saveUpdates (dataArray) {
      let request = {
        controller: '/Servicio/' + this.idServ,
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err.message);
          responseData = {
            data: null,
            status: false
          };
          this.$router.push({ name: 'servicios' });
        });

      return responseData;
    },
    async refillData () {
      this.idServ = this.arrayServ.id;
      this.name = this.arrayServ.name;
      this.orden = this.arrayServ.displayOrder;
      this.url = this.arrayServ.url;
      this.typeIndicadores = !(this.arrayServ.tags === undefined || this.arrayServ.tags.length === 0 || this.arrayServ.tags.indexOf('TYPE_INDICADORES') === -1);

      let resources = this.arrayServ.resources;
      let logotipo = this.searchResource(resources, 'Logotipo');
      let imagen = this.searchResource(resources, 'Imagen');
      let video = this.searchResource(resources, 'Video');
      let documento = this.searchResource(resources, 'Documento');

      if (logotipo !== null) {
        this.imgLogotipo = await this.getImgFromBase64(logotipo.url);
      }
      if (imagen !== null) {
        this.imgImagen = await this.getImgFromBase64(imagen.url);
      }

      if (video !== null) {
        this.video = video;
      }
      if (documento !== null) {
        this.documento = documento;
      }

      this.descripcion = this.arrayServ.description;
      this.visible = this.arrayServ.visible;

      this.appSelected = this.setAppSelected(this.dataServ.aplicacion);
    },
    setAppSelected (idApp) {
      let returnData = null;
      this.appOptions.forEach((element) => {
        if (element.id === idApp) returnData = element;
      });
      return returnData;
    },
    async setAppServ (callback) {
      let dataArray = this.appSelected == null ? [] : [ this.appSelected.id ];

      let request = {
        controller: '/Servicio/' + this.dataServ.id + '/aplicacion-relationship',
        filter: {},
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('PF/postSuit', request)
        .then((response) => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch((err) => {
          this.showError(err);

          responseData = {
            data: null,
            status: false
          };
        });

      callback(responseData);
    },
    filterFn (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase();
        this.appOptions = this.arrayApps.filter(v => v.name.toLowerCase().indexOf(needle) > -1);
      });
    },
    deleteVideo () {
      this.videoId = this.video.id;
      this.video = {
        file: null,
        name: ''
      };
      this.updateVideo = true;
    },
    deleteDocumento () {
      this.documentoId = this.documento.id;
      this.documento = {
        file: null,
        name: ''
      };
      this.updateDocumento = true;
    },
    fillTags () {
      let tags = [];
      if (this.typeIndicadores) {
        tags.push('TYPE_INDICADORES');
      }
      return tags;
    }
  },
  watch: {
    dataServ: {
      handler: function () {
        this.arrayServ = this.dataServ;
        if (Object.entries(this.dataServ).length > 0) {
          this.refillData();
        }
      },
      immediate: true
    },
    arrayApps: {
      handler: function () {
        this.appOptions = this.arrayApps;
        if (Object.entries(this.arrayApps).length > 0) {
          this.refillData();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-serv {
  .input-row {
    padding: 16px 0px;
  }
  /* Desplaza el contador de caracteres a la izquierda */
  &:deep() {
    .q-field__messages {
      display: contents;
    }
    .q-field__counter {
      padding-left: 4px;
    }
  }
}

.container-images {
  padding-left: 18px;
}

.container-order {
  padding: 16px 0px;
}

.info-box {
  display: flex;
  align-items: center;
}

.txt-info {
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: 1.5px;
  color: rgba(0, 0, 0, 0.87);
}
.divUploadDocumento, .divUploadVideo{
  display: flex;
  justify-content: center;
}
</style>
